import { C02AccordionViewMoreProps } from './C02AccordionViewMore';
import { useI18n } from 'next-localization';
import { TextAccordionProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateC02AccordionViewMoreModel(
  props?: C02AccordionViewMoreProps
): TextAccordionProps {
  const { params, fields } = props || {};
  const { t } = useI18n() || {};
  const { renderRichText, renderText } = useConditionalRendering();
  const showMoreText = t('Text Accordion-Show More');
  const showLessText = t('Text Accordion-Show Less');

  return {
    alwaysVisibleText: renderRichText(props?.fields?.AlwaysVisibleText, {
      required: true,
    }),
    bodyCopyAlignment: getDroplink(params?.BodyCopyAlignment, 'left'),
    headlineAlignment: getDroplink(params?.TitleAlignment, 'left'),
    headlineTag: getDroplink(params?.TitleType, 'p'),
    headline: renderText(fields?.Title),
    hiddenText: renderRichText(fields?.HiddenText, { required: true }),
    showLessText,
    showMoreText,
  };
}
